const brandsId: Record<string, string> = {
  demo: '1241',
  MPR: '1763',
  reunion: '496',
};

export const getBrandId = (customerId: string): string => {
  return brandsId[customerId];
};
